import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './style/LeafletMap.css';
import L from 'leaflet';

// Убедитесь, что пути к иконкам правильные
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

const customIcon = new L.Icon({
    iconUrl: markerIcon,
    iconRetinaUrl: markerIcon2x,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

const locations = [
    { lat: 51.169392, lng: 71.449074, text: "Магазин 1" },
    { lat: 51.170672, lng: 71.433945, text: "Магазин 2" },
    { lat: 51.155715, lng: 71.464231, text: "Магазин 3" }
];

function LeafletMap() {
    return (
        <div className="map-wrapper">
            <MapContainer className="map-container" center={[51.169392, 71.449074]} zoom={13} attributionControl={false}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {locations.map((location, index) => (
                    <Marker key={index} position={[location.lat, location.lng]} icon={customIcon}>
                        <Popup>{location.text}</Popup>
                    </Marker>
                ))}
                <div className="leaflet-bottom">
                    © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors
                </div>
            </MapContainer>
        </div>
    );
}

export default LeafletMap;
